export default "__VITE_ASSET__579c765d__"